module.exports = __webpack_public_path__ + "img/main-list_09.60e1a226.jpg";